"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackedRoute = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _mixpanel = require("../apis/mixpanel");

var _index = require("../index");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const TrackedRoute = props => {
  const {
    title,
    trackEvent
  } = props,
        routeProps = _objectWithoutProperties(props, ["title", "trackEvent"]);

  (0, _react.useEffect)(() => {
    if (routeProps.path) {
      const pageProps = {
        'Page Path': routeProps.path
      };

      if (title) {
        pageProps['Page Title'] = title;
      } // pageProps are "super props" so each event on a page has the page set


      (0, _mixpanel.mxSuperProps)(pageProps);
      trackEvent(_index.MixpanelDefaultEventTitles.PageOpen, pageProps);
    }
  }, [routeProps, title]);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, routeProps);
};

exports.TrackedRoute = TrackedRoute;